import { useEffect, useState } from "react";

/**
 * Cycles through a list of two-line headings with a typewriter effect:
 * type line 1, type line 2, hold, delete line 2, delete line 1, advance.
 */
export default function TypewriterCycle({
  lines, // [[l1, l2], [l1, l2], ...]
  typeSpeed = 42,
  deleteSpeed = 22,
  hold = 2800,
  className = "",
  line1ClassName = "",
  line2ClassName = "",
}) {
  const [phase, setPhase] = useState("typing1"); // typing1, typing2, holding, deleting2, deleting1
  const [index, setIndex] = useState(0);
  const [text1, setText1] = useState("");
  const [text2, setText2] = useState("");

  useEffect(() => {
    const [l1, l2] = lines[index];
    let timer;
    if (phase === "typing1") {
      if (text1.length < l1.length) {
        timer = setTimeout(() => setText1(l1.slice(0, text1.length + 1)), typeSpeed);
      } else {
        timer = setTimeout(() => setPhase("typing2"), 380);
      }
    } else if (phase === "typing2") {
      if (text2.length < l2.length) {
        timer = setTimeout(() => setText2(l2.slice(0, text2.length + 1)), typeSpeed);
      } else {
        timer = setTimeout(() => setPhase("holding"), hold);
      }
    } else if (phase === "holding") {
      timer = setTimeout(() => setPhase("deleting2"), 0);
    } else if (phase === "deleting2") {
      if (text2.length > 0) {
        timer = setTimeout(() => setText2(text2.slice(0, -1)), deleteSpeed);
      } else {
        timer = setTimeout(() => setPhase("deleting1"), 200);
      }
    } else if (phase === "deleting1") {
      if (text1.length > 0) {
        timer = setTimeout(() => setText1(text1.slice(0, -1)), deleteSpeed);
      } else {
        setIndex((index + 1) % lines.length);
        setPhase("typing1");
      }
    }
    return () => clearTimeout(timer);
  }, [phase, text1, text2, index, lines, typeSpeed, deleteSpeed, hold]);

  const showCaret =
    phase === "typing1" || phase === "deleting1"
      ? "line1"
      : phase === "typing2" || phase === "deleting2"
        ? "line2"
        : "line2";

  return (
    <span className={className} data-testid="rotating-heading">
      <span className={`block ${line1ClassName}`}>
        {text1}
        <span
          className={`inline-block w-[3px] align-baseline ml-0.5 bg-current animate-tw-caret ${
            showCaret === "line1" ? "opacity-90" : "opacity-0"
          }`}
          style={{ height: "0.85em" }}
          aria-hidden
        />
      </span>
      <span className={`block ${line2ClassName}`}>
        {text2}
        <span
          className={`inline-block w-[3px] align-baseline ml-0.5 bg-current animate-tw-caret ${
            showCaret === "line2" ? "opacity-90" : "opacity-0"
          }`}
          style={{ height: "0.85em" }}
          aria-hidden
        />
      </span>
    </span>
  );
}
